import { ISelectCountHashmap } from '../../types/plan'

const getNewCounts = (selectedDrugs: ISelectCountHashmap, limitInput: number): ISelectCountHashmap => {
  return Object.keys(selectedDrugs).reduce<ISelectCountHashmap>((acc, curr) => {
    if (acc[curr].selected) {
      return {
        ...acc,
        [curr]: { selected: false, count: limitInput }
      }
    }

    return acc
  }, selectedDrugs)
}

export {
  getNewCounts
}
